// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-using-statement
require('../internals/define-well-known-symbol')('dispose');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/esnext.symbol.dispose.js
// module id = 609
// module chunks = 0